export const encodeKey = (key) => {
    if (!key) {
        return null;
    }
    return key.replaceAll('"', "&quote;");
};
//# sourceMappingURL=encodeKey.js.map